/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_025: Question = {
  id: 'pres-025-complexes-milieux-humides',
  oldId: '39',
  title: 'Nombre de complexes de milieux humides',
  number: '3.9',
  description: ['(groupement de milieux humides séparés par moins de 30m) de milieux humides'],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

const question_pres_025__v3: Question = {
  ...question_pres_025,
  number: '3.3',
  description: ['Groupement de milieux humides séparés par moins de 30m de milieux humides'],
  frequency: 4,
};

export const question_pres_025_v2: Question = question_pres_025;
export const question_pres_025_v3: Question = question_pres_025__v3;
